module.exports = __webpack_public_path__ + "static/media/dice-three.fc6382e7.svg";